import { DEBUGS } from "@configs";
import React from "react";

export const debugLog = (message: string) => {
  if (DEBUGS) {
    console.log(message);
  }
};

export const DebugPage = ({
  children,
}: {
  children: React.ReactNode[] | React.ReactNode;
}) => {
  if (DEBUGS) {
    return children;
  } else {
    return null;
  }
};
